/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Grid from '../../../../../../SharedModules/Table/TableGridWithFeatures';
import CustomDateComponent from '../../CustomDateComponent';
import PriceCustomComponent from './PriceCustomComponent';
import ViewHistoryComponent from '../../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../../SharedModules/AgGridUtilities/suppressNavigation';

const PriceTableComponent = ({
  tableData,
  tableHead,
  selectedPriceType,
  gridApi,
  setGridApi,
  setColumnApi,
  fullScreen,
  setFullScreen,
  isEnablebyRole
}) => {
  const [gridData, setGridData] = useState([]);
  const [tableCount, setTableCount] = useState(0);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setTableCount(params.api.getDisplayedRowCount());
  }, []);

  useEffect(() => {
    if (selectedPriceType && tableData.length > 0) {
      const data = [...tableData];
      setGridData(
        data.filter(
          (item) =>
            item.priceId &&
            item.priceId.priceTypeCd &&
            item.priceId.priceTypeCd === selectedPriceType
        )
      );
    } else {
      setGridData([]);
    }
  }, [tableData, selectedPriceType]);

  useEffect(() => {
    gridApi && gridApi.setFilterModel(null);
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi, gridData]);

  useEffect(() => {
    return () => {
      setGridApi(null);
      setColumnApi(null);
    };
  }, []);

  const readOnlyRenderers = ['dateComponent', 'priceComponent'];

  /** When true (from parent), user must not edit date/price cells — align with grid `editable` + renderer `readOnly`. */
  const columnDefs = useMemo(
    () =>
      !tableHead?.length
        ? tableHead || []
        : tableHead.map((col) =>
            readOnlyRenderers.includes(col.cellRenderer)
              ? {
                  ...col,
                  editable: false,
                  cellRendererParams: {
                    ...(col.cellRendererParams || {}),
                    readOnly: true,
                  },
                }
              : {...col,
                editable:false
              }
          ),
    [tableHead]
  );

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
    setFullScreen(!fullScreen);
  };

  return (
    <div className="table-container eightRecords mt-3 col-12">
      <Grid
        gridHeight={fullScreenView ? '100vh' : 350}
        rowData={gridData}
        fullScreenView={fullScreen}
        applyFilter={false}
        // defaultCol={{editable:false}}
        columnDefs={columnDefs}
        data-testid="onEditingStopped"
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        singleClickEdit={false}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile
        fileName="Price"
        onGridReady={onGridReady}
        frameworkComponents={{
          priceComponent: PriceCustomComponent,
          dateComponent: CustomDateComponent,
        }}
      />

      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="PRICE"
          keyValue={keyValue}
        />
      )}
    </div>
  );
};

export default PriceTableComponent;
